var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9121 0.987525C10.7644 0.184112 9.23678 0.184109 8.08905 0.987524L2.35773 4.99944C1.39222 5.6753 0.855367 6.81078 0.945758 7.98587L1.53327 15.6236C1.64408 17.064 2.94925 18.111 4.37946 17.9067L7.02081 17.5294C8.25243 17.3534 9.16726 16.2986 9.16726 15.0545V14C9.16726 13.5398 9.54035 13.1667 10.0006 13.1667C10.4608 13.1667 10.8339 13.5398 10.8339 14V15.0545C10.8339 16.2986 11.7487 17.3534 12.9804 17.5294L15.6217 17.9067C17.0519 18.111 18.3571 17.064 18.4679 15.6236L19.0554 7.98587C19.1458 6.81078 18.609 5.67531 17.6434 4.99944L11.9121 0.987525ZM9.04482 2.35291C9.61868 1.9512 10.3825 1.9512 10.9564 2.35291L16.6877 6.36483C17.1704 6.70276 17.4389 7.2705 17.3937 7.85805L16.8061 15.4957C16.7692 15.9759 16.3342 16.3249 15.8574 16.2568L13.2161 15.8795C12.8055 15.8208 12.5006 15.4692 12.5006 15.0545V14C12.5006 12.6193 11.3813 11.5 10.0006 11.5C8.61988 11.5 7.50059 12.6193 7.50059 14V15.0545C7.50059 15.4692 7.19565 15.8208 6.78511 15.8795L4.14376 16.2568C3.66703 16.3249 3.23197 15.9759 3.19503 15.4957L2.60752 7.85804C2.56232 7.2705 2.83075 6.70276 3.3135 6.36483L9.04482 2.35291Z",
    fill: "#F2F2F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.7e624a601603dbeac2b9eaae99e54c77.svg";
export { ForwardRef as ReactComponent };